/** @format */
import angular from 'angular';
(function () {
  angular.module('student.timing.route', ['ui.router', 'ui.router.upgrade', 'student.timing.timing']).config(["$stateProvider", $stateProvider => {
    const setTimingViewData = function ($scope, plans, selectedPlan) {
      $scope.plans = plans;
      $scope.selectedPlan = selectedPlan;
    };
    setTimingViewData.$inject = ["$scope", "plans", "selectedPlan"];
    $stateProvider.state('student.logged-in.plan.timing', {
      url: '/timing',
      headerParams: {
        displayNameKey: 'APPLICATION_TIMING',
        skipBreadcrumb: false
      },
      redirectTo: transition => {
        const selectedModuleId = transition.params().selectedModuleId ?? '';
        const planId = transition.params().planId ?? '';
        return {
          state: 'student.logged-in.plan.timing.untimed',
          params: {
            selectedModuleId,
            planId
          }
        };
      }
    }).state('student.logged-in.plan.timing.untimed', {
      url: '/:selectedModuleId?',
      template: '<timing plans="plans" selected-plan="selectedPlan"></timing>',
      data: {
        showHome: true,
        hideLastNode: false,
        hideFooter: true,
        browserTabTitle: 'APPLICATION_TIMING'
      },
      headerParams: {
        displayNameKey: 'APPLICATION_TIMING',
        skipBreadcrumb: true
      },
      controller: setTimingViewData
    });
  }]);
})();